import { FILE_TYPE_LIMITS } from '../utils/constants';

export const DIGITAL_UPLOAD_ALLOWED_EXTENSIONS = [
  ...new Set(
    Object.values(FILE_TYPE_LIMITS).flatMap((cfg) => cfg.extensions),
  ),
].sort((a, b) => a.localeCompare(b));
